import { computed, ref, nextTick, watch, onMounted } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-27b7e811"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mainpage"
};
const _hoisted_2 = {
  class: "card"
};
const _hoisted_3 = {
  key: 0,
  class: "back-box",
  style: {
    "margin-bottom": "12px"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}), /*#__PURE__*/_createTextVNode(" 谷歌商品配置 ")], -1));
const _hoisted_5 = {
  class: "optionLabel"
};
const _hoisted_6 = {
  class: "optionDescribtion"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "内购ID", -1));
const _hoisted_8 = {
  key: 0,
  class: "card planCard"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}), /*#__PURE__*/_createTextVNode(" 基础方案 ")], -1));
const _hoisted_10 = {
  class: "card priceCard"
};
const _hoisted_11 = {
  class: "title"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}, null, -1));
const _hoisted_13 = {
  class: "price-tab-label"
};
const _hoisted_14 = {
  key: 0
};
const _hoisted_15 = {
  key: 1,
  class: "price-input-flex"
};
const _hoisted_16 = {
  class: "price-input-flex-item"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "currency-tip"
}, " *该产品默认币种非USD，可在左侧输入框内填写美元金额，系统会自动换算成默认币种配置 ", -1));
const _hoisted_18 = {
  class: "taxRateBox"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "taxRateTitle"
}, "新加坡 GST 调价", -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "rate-tips"
}, "开启后新加坡本地价格将自动上调9%，以规避新加坡地区GST税费。", -1));
const _hoisted_21 = [_hoisted_19, _hoisted_20];
const _hoisted_22 = {
  class: "third-party-payment-item"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "third-party-payment-tips"
}, " 该功能尚在选品测试阶段，请确认游戏已接入「第三方支付」功能，否则配置无效； ", -1));
const _hoisted_24 = {
  key: 1,
  class: "card",
  style: {
    "padding": "0"
  }
};
const _hoisted_25 = {
  class: "selectBox"
};
import useGetSelect from '@/hooks/useGetSelect';
import MultiComponents from './components/MultiComponents.vue';
import PriceBlock from './components/PriceBlock.vue';
import TierDefaultPrice from './components/TierDefaultPrice.vue';
import TierLocalPriceTable from './components/TierLocalPriceTable.vue';
import TierTemplateSwitch from './components/TierTemplateSwitch.vue';
import UnusedTierConfirmModal from './components/UnusedTierConfirmModal.vue';
import PriceModeConfirmModal from './components/PriceModeConfirmModal.vue';
import ThirdPartyPricePanel from './components/ThirdPartyPricePanel.vue';
import XsollaNativePriceFields from './components/XsollaNativePriceFields.vue';
import { fetchTierTemplateMappings, getUnusedTiers, filterUsedTierPrices, buildTieredPricing } from './services/tieredPricing';
import { DEFAULT_MISSING_OFFICIAL_TIP, calcDiscountRate } from './services/thirdPartyPricing';
import { createDefaultXsollaPayInfo, findRussiaNativePrice, isValidXsollaSku, mergeXsollaChannelPrices, normalizeXsollaPayInfo, updateXsollaRussiaPrice, updateXsollaVat } from './services/xsollaPricing';
import BasicPlanNotAuto from './components/BasicPlanNotAuto.vue';
import BasicPlanAuto from './components/BasicPlanAuto.vue';
import DiscountPlan from './components/DiscountPlan.vue';
import useDetailHooks from './hooks/useDetailHooks';
import useManualProdId from './hooks/useManualProdId';
import RecordDrawer from './components/RecordDrawer.vue';
import { cloneDeep } from 'lodash';
import { queryPkgInfo, queryGoods, addGoods, updGoods, getLastLangInfo, queryPriceList, translator } from '@/api/goodsSetting';
import { useRoute, useRouter } from 'vue-router';
import { QuestionCircleOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { awaitWrap, getNode, OK, reportEvent } from '@/common';
import { useStore } from '@/store';
import { defineComponent } from 'vue';
const __default__ = defineComponent({
  name: 'goodsSettingDetail'
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const layoutStore = useStore();
    const submitBlockStyle = computed(() => ({
      left: (layoutStore.isCollapsed ? 74 : 180) + 'px'
    }));
    const route = useRoute();
    const router = useRouter();
    const {
      getCountryCoinOptions
    } = useGetSelect('google');
    const {
      prodTypeOptions,
      detailFormInit,
      describtionKey,
      purchaseType,
      rentalOptions,
      verifyNumber,
      validatePidAuto,
      validateGooglePidAuto
    } = useDetailHooks();
    const recordVisible = ref(false);
    const disabled = ref(false); // 禁用改动
    const priceChannelTab = ref('google');
    // 文案走 title，label 让位给页签插槽（option 上的 label 会覆盖插槽）
    const priceChannelTabOptions = [{
      title: '谷歌官方价格',
      value: 'google'
    }, {
      title: '三方支付',
      value: 'xsolla'
    }];
    // 谷歌渠道的三方支付只有 Xsolla 一个渠道，仍保留单选形态与 iOS 对齐
    const GOOGLE_THIRD_PARTY_CHANNEL_OPTIONS = [{
      label: 'Xsolla',
      value: 'xsolla_pay'
    }];
    // 定价模式：single 单一默认价格 / tiered 多默认价格（按国家分层定价）
    const priceMode = ref('single');
    // 谷歌全部商品类型均支持分层定价
    const showTieredOption = computed(() => true);
    // 层级模板开关（仅多默认价格模式显示）
    const tierTemplateEnabled = ref(true);
    // 是否新建（非编辑/查看）——仅新建场景回填模板
    const isNewGoods = computed(() => !['edit', 'watch'].includes(queryParams.value.type || ''));
    // 废弃层级二次确认弹窗
    const unusedModalOpen = ref(false);
    const unusedTiers = ref([]);
    const tieredSaving = ref(false);
    let timout = null;
    const queryParams = ref({
      prodChnl: '',
      dbtId: '',
      id: null,
      type: ''
    });
    const saveNext = ref(false); // 是否连续创建，保存后留在本页，清空配置信息，保留其他例如价格信息
    const typeDisabled = ref(true);
    const multiComponentRef = ref(null); // 组件ref
    const priceBlockRef = ref(null);
    const tierDefaultRef = ref(null); // 多默认价格-层级默认价组件
    const tierLocalRef = ref(null); // 多默认价格-本地价格表组件
    // 有效层级（供本地价格表层级下拉）：仅已填基准价的层级（问题2，空层级不可选）；T1 始终在内
    const tierLevels = computed(() => {
      var _tierDefaultRef$value;
      const levels = (((_tierDefaultRef$value = tierDefaultRef.value) === null || _tierDefaultRef$value === void 0 ? void 0 : _tierDefaultRef$value.validTiers()) || []).map(t => t.tierCode);
      return levels.length ? levels : ['T1'];
    });
    const myFormRef = ref(null);
    const discountPlanRef = ref(null);
    // 折扣方案价格来源随定价模式切换：多默认价取分层本地价表，单一价取单一价格块
    const discountPriceArr = computed(() => {
      var _priceBlockRef$value;
      if (priceMode.value === 'tiered') {
        var _tierLocalRef$value;
        return (((_tierLocalRef$value = tierLocalRef.value) === null || _tierLocalRef$value === void 0 ? void 0 : _tierLocalRef$value.list) || []).map(row => ({
          regionCode: row.regionCode,
          regionName: row.regionName,
          prodPrice: row.prodPrice,
          originProdPrice: row.originProdPrice
        }));
      }
      return ((_priceBlockRef$value = priceBlockRef.value) === null || _priceBlockRef$value === void 0 ? void 0 : _priceBlockRef$value.originData) || [];
    });
    const loading = ref(false);
    const priceLoading = ref(false);
    const lastLangInfo = ref([]);
    const showLastLangInfo = ref(false); // 历史语言信息显示隐藏
    const saveLoading = ref(false); // 保存按钮可用性
    const originUsdPrice = ref(''); // 美元价格
    const taxRateSwitch = ref(true); // 新加坡税率开关
    const settingForm = ref(cloneDeep(detailFormInit));
    const thirdPartyPanelRef = ref(null);
    const xsollaNativeRef = ref(null);
    const xsollaConfig = ref(createDefaultXsollaPayInfo());
    // 渠道单选：只有 Xsolla，默认选中，切换渠道只清报错（与 iOS 一致）
    const thirdPartyChannel = ref('xsolla_pay');
    // iOS 面板只认 { prodPrice, promotionDesc }，读写都落到 xsollaConfig 上
    const thirdPartyDraft = computed({
      get: () => ({
        prodPrice: xsollaConfig.value.prodPrice || '',
        promotionDesc: xsollaConfig.value.promotionDesc || ''
      }),
      set: draft => {
        xsollaConfig.value = {
          ...xsollaConfig.value,
          prodPrice: draft.prodPrice,
          promotionDesc: draft.promotionDesc
        };
      }
    });
    const xsollaPriceLoading = ref(false);
    // 编辑回显中：从进页面到详情（含非 USD 的美元价、分层回显）落定为止
    const detailLoading = ref(false);
    // 三方支付的官方价基准还在加载/重算：此时三方面板跟着 loading，不预填、不校验
    const officialPriceLoading = computed(() => detailLoading.value || priceLoading.value);
    const showXsollaTab = computed(() => ['10', '20'].includes(settingForm.value.prodType));
    const cCountry = ref('');
    const originPriceList = ref([]); // 最初的价格历史合集
    const {
      isManualProdId,
      handleProdIdFocus,
      handleProdIdBlur,
      resetManualProdId
    } = useManualProdId(() => settingForm.value.prodId);
    const getDetail = async () => {
      detailLoading.value = true;
      try {
        await loadDetail();
      } finally {
        // 等分层回显在 nextTick 里接上 priceLoading，再解除，避免中间闪一下空官方价
        await nextTick();
        detailLoading.value = false;
      }
    };
    const loadDetail = async () => {
      const res = await queryGoods({
        id: queryParams.value.id
      });
      if ((res === null || res === void 0 ? void 0 : res.code) === '0') {
        var _settingForm$value, _res$data, _res$data2;
        const prodPriceCurrency = (_settingForm$value = settingForm.value) === null || _settingForm$value === void 0 ? void 0 : _settingForm$value.prodPriceCurrency;
        settingForm.value = {
          ...settingForm.value,
          ...res.data,
          prodPriceCurrency
        };
        xsollaConfig.value = normalizeXsollaPayInfo((_res$data = res.data) === null || _res$data === void 0 || (_res$data = _res$data.channelPrices) === null || _res$data === void 0 || (_res$data = _res$data.priceInfo) === null || _res$data === void 0 ? void 0 : _res$data.xsolla_pay);
        // 编辑、查看时回显税率开关状态
        if (['edit', 'watch'].includes(queryParams.value.type) && showRateSwitch.value) {
          var _res$data$bizInfo$sgt, _res$data$bizInfo;
          taxRateSwitch.value = (_res$data$bizInfo$sgt = (_res$data$bizInfo = res.data.bizInfo) === null || _res$data$bizInfo === void 0 || (_res$data$bizInfo = _res$data$bizInfo.sgtPriceAdjustment) === null || _res$data$bizInfo === void 0 ? void 0 : _res$data$bizInfo.enabled) !== null && _res$data$bizInfo$sgt !== void 0 ? _res$data$bizInfo$sgt : false;
        }
        // 保存一份最初的价格合集，用来处理调整区域列表
        originPriceList.value = res.data.productNativePrice;
        // 多默认价商品：prodPrice 存的是 T1、productNativePrice 是分层生成的本地价，
        // 不能回填到单一价格块（否则切到单一会带出多默认价的值）。单一块保持空。
        const isTiered = ((_res$data2 = res.data) === null || _res$data2 === void 0 || (_res$data2 = _res$data2.bizInfo) === null || _res$data2 === void 0 || (_res$data2 = _res$data2.tieredPricing) === null || _res$data2 === void 0 ? void 0 : _res$data2.pricingMode) === 'MULTI_DEFAULT_PRICE';
        if (!isTiered) {
          var _priceBlockRef$value2;
          (_priceBlockRef$value2 = priceBlockRef.value) === null || _priceBlockRef$value2 === void 0 || _priceBlockRef$value2.init(res.data);
          if (prodPriceCurrency !== 'USD') {
            var _res$data3;
            await getUSDPrice();
            // 初始化默认币种为非美元时，美元价格需要从queryGoods接口获取不能从价格回显位置获取
            originUsdPrice.value = res === null || res === void 0 || (_res$data3 = res.data) === null || _res$data3 === void 0 || (_res$data3 = _res$data3.productNativePrice) === null || _res$data3 === void 0 || (_res$data3 = _res$data3.filter(item => {
              return item.regionName === '美国';
            })) === null || _res$data3 === void 0 || (_res$data3 = _res$data3[0]) === null || _res$data3 === void 0 ? void 0 : _res$data3.prodPrice;
          }
        } else {
          settingForm.value.prodPrice = '';
        }
        if (['10', '20'].includes(settingForm.value.prodType)) {
          var _res$data$bizInfo$goo, _res$data$bizInfo2, _res$data$bizInfo$goo2, _res$data$bizInfo3;
          // 给购买类型和租期赋值
          const purchaseType = (_res$data$bizInfo$goo = (_res$data$bizInfo2 = res.data.bizInfo) === null || _res$data$bizInfo2 === void 0 || (_res$data$bizInfo2 = _res$data$bizInfo2.googleRentalConfig) === null || _res$data$bizInfo2 === void 0 ? void 0 : _res$data$bizInfo2.purchaseType) !== null && _res$data$bizInfo$goo !== void 0 ? _res$data$bizInfo$goo : 'buy';
          const rentalPeriod = (_res$data$bizInfo$goo2 = (_res$data$bizInfo3 = res.data.bizInfo) === null || _res$data$bizInfo3 === void 0 || (_res$data$bizInfo3 = _res$data$bizInfo3.googleRentalConfig) === null || _res$data$bizInfo3 === void 0 ? void 0 : _res$data$bizInfo3.rentalPeriod) !== null && _res$data$bizInfo$goo2 !== void 0 ? _res$data$bizInfo$goo2 : 'PT24H';
          settingForm.value.purchaseType = purchaseType;
          settingForm.value.rentalPeriod = rentalPeriod;
        }
        restoreTiered(res.data);
      }
    }; // 查询详情信息
    // 分层定价回显：读取 bizInfo.tieredPricing，铺层级默认价与本地价格表（不重新调接口①）
    const restoreTiered = data => {
      var _data$bizInfo;
      const tp = data === null || data === void 0 || (_data$bizInfo = data.bizInfo) === null || _data$bizInfo === void 0 ? void 0 : _data$bizInfo.tieredPricing;
      if (!tp || tp.pricingMode !== 'MULTI_DEFAULT_PRICE') return;
      priceMode.value = 'tiered';
      tierTemplateEnabled.value = !!tp.saveAsTemplate;
      tierTemplateApplied.value = true; // 回显不再自动拉模板
      tieredRestoring.value = true; // 首次回显：抑制接口①，本地价取 productNativePrice
      nextTick(() => {
        var _tierDefaultRef$value2, _tierLocalRef$value2;
        (_tierDefaultRef$value2 = tierDefaultRef.value) === null || _tierDefaultRef$value2 === void 0 || _tierDefaultRef$value2.init((tp.tierPrices || []).map(t => ({
          tierCode: t.tierCode,
          regionCode: t.regionCode,
          prodPriceCurrency: t.prodPriceCurrency,
          prodPrice: t.prodPrice,
          priceTier: t.priceTier,
          priceId: t.priceId,
          // 谷歌按币种回填两个输入框
          usd: t.prodPriceCurrency === 'USD' ? t.prodPrice : '',
          localPrice: t.prodPriceCurrency !== 'USD' ? t.prodPrice : ''
        })));
        (_tierLocalRef$value2 = tierLocalRef.value) === null || _tierLocalRef$value2 === void 0 || _tierLocalRef$value2.initFromSaved(data.productNativePrice || [], tp.countryTierMappings || []);
        // 谷歌非 USD 账号：回显时把已存币种换算回填另一币种框，使 USD/账号币种两栏都展示
        if (settingForm.value.prodPriceCurrency !== 'USD') {
          var _tierDefaultRef$value3;
          (_tierDefaultRef$value3 = tierDefaultRef.value) === null || _tierDefaultRef$value3 === void 0 || (_tierDefaultRef$value3 = _tierDefaultRef$value3.list) === null || _tierDefaultRef$value3 === void 0 || _tierDefaultRef$value3.forEach(t => {
            const from = t.usd ? 'usd' : t.localPrice ? 'local' : null;
            if (from) convertTierAmount(t, from, true);
          });
        }
        // 回显（含 tierLevels 变化引发的 watch）落定后解除抑制，后续修改照常重算接口①
        nextTick(() => {
          tieredRestoring.value = false;
        });
      });
    };
    // 获取价格回显
    const getUSDPrice = async () => {
      priceLoading.value = true;
      try {
        let params = {
          pkg: settingForm.value.pkg,
          prodChnl: queryParams.value.prodChnl,
          prodPrice: settingForm.value.prodPrice,
          prodPriceCurrency: settingForm.value.prodPriceCurrency,
          prodType: settingForm.value.prodType,
          dbtId: queryParams.value.dbtId
        };
        // 渠道谷歌+默认币种是SGD则增加参数
        if (showRateSwitch.value) {
          params = Object.assign({}, params, {
            applySgtAdjustment: taxRateSwitch.value
          });
        }
        const res = await queryPriceList(params);
        if ((res === null || res === void 0 ? void 0 : res.code) === '0') {
          var _res$data4;
          originUsdPrice.value = res === null || res === void 0 || (_res$data4 = res.data) === null || _res$data4 === void 0 || (_res$data4 = _res$data4.productNativePrice) === null || _res$data4 === void 0 || (_res$data4 = _res$data4.filter(item => {
            return item.regionName === '美国';
          })) === null || _res$data4 === void 0 || (_res$data4 = _res$data4[0]) === null || _res$data4 === void 0 ? void 0 : _res$data4.prodPrice;
        }
      } catch (error) {
        message.error('价格处理失败，请稍后重试');
        return false;
      } finally {
        priceLoading.value = false;
      }
    };
    const getXsollaDefaultPriceFromGoogle = () => {
      var _tierDefaultRef$value4;
      const googlePrice = priceMode.value === 'tiered' ? (_tierDefaultRef$value4 = tierDefaultRef.value) === null || _tierDefaultRef$value4 === void 0 || (_tierDefaultRef$value4 = _tierDefaultRef$value4.list) === null || _tierDefaultRef$value4 === void 0 || (_tierDefaultRef$value4 = _tierDefaultRef$value4.find(item => item.tierCode === 'T1')) === null || _tierDefaultRef$value4 === void 0 ? void 0 : _tierDefaultRef$value4.usd : settingForm.value.prodPriceCurrency === 'USD' ? settingForm.value.prodPrice : originUsdPrice.value;
      const price = Number(googlePrice);
      return Number.isFinite(price) && price > 0 ? price.toFixed(2) : '';
    };
    // 7 折校验与折扣基准：谷歌官方美元价（默认币种非 USD 时取美元输入框，分层取 T1）
    const thirdPartyOfficialPrice = computed(() => getXsollaDefaultPriceFromGoogle());
    const thirdPartyOfficialTip = computed(() => priceMode.value === 'tiered' ? '请先填写 T1 层级默认价' : DEFAULT_MISSING_OFFICIAL_TIP);
    // 俄罗斯本地价以 Xsolla 默认价为基准，默认价失焦落定后重算
    const refreshXsollaRuPrice = async () => {
      if (!xsollaConfig.value.enableThirdPay) return false;
      const defaultPrice = xsollaConfig.value.prodPrice;
      if (!defaultPrice || Number(defaultPrice) <= 0) {
        message.warning('请先填写 Xsolla 默认价格');
        return false;
      }
      xsollaPriceLoading.value = true;
      try {
        var _res$data5;
        const res = await queryPriceList({
          pkg: settingForm.value.pkg,
          prodChnl: queryParams.value.prodChnl,
          prodPrice: Number(defaultPrice).toFixed(2),
          prodPriceCurrency: 'USD',
          prodType: settingForm.value.prodType,
          dbtId: queryParams.value.dbtId,
          vatEnabled: xsollaConfig.value.vatEnabled
        });
        if ((res === null || res === void 0 ? void 0 : res.code) !== '0') return false;
        const russiaPrice = findRussiaNativePrice((res === null || res === void 0 || (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.productNativePrice) || []);
        if (!(russiaPrice !== null && russiaPrice !== void 0 && russiaPrice.prodPrice)) {
          message.error('俄罗斯本地价格生成失败，请稍后重试');
          return false;
        }
        xsollaConfig.value = updateXsollaRussiaPrice(xsollaConfig.value, russiaPrice.originProdPrice || russiaPrice.prodPrice, russiaPrice.prodPrice);
        return true;
      } catch (error) {
        return false;
      } finally {
        xsollaPriceLoading.value = false;
      }
    };
    // 官方价改动后刷新折扣描述（俄罗斯价的重算挂在用户改价的落点上，不用 watch，避免回显时误重算）
    watch(thirdPartyOfficialPrice, () => {
      var _thirdPartyPanelRef$v;
      if (!xsollaConfig.value.enableThirdPay) return;
      (_thirdPartyPanelRef$v = thirdPartyPanelRef.value) === null || _thirdPartyPanelRef$v === void 0 || _thirdPartyPanelRef$v.refreshPromotionDesc();
    });
    // 切换渠道不动已填价格，只清掉上一次的报错
    watch(thirdPartyChannel, () => {
      var _thirdPartyPanelRef$v2;
      return (_thirdPartyPanelRef$v2 = thirdPartyPanelRef.value) === null || _thirdPartyPanelRef$v2 === void 0 ? void 0 : _thirdPartyPanelRef$v2.clearValidate();
    });
    // 切回三方支付页签：默认价为空时用谷歌官方价预填，再按最新价格重新校验
    // 三方价格还没填时不校验，避免一进来就飘红
    const onPriceChannelTabChange = async tab => {
      var _xsollaConfig$value$p;
      if (tab !== 'xsolla') {
        var _thirdPartyPanelRef$v3;
        (_thirdPartyPanelRef$v3 = thirdPartyPanelRef.value) === null || _thirdPartyPanelRef$v3 === void 0 || _thirdPartyPanelRef$v3.clearValidate();
        return;
      }
      // 官方价还在加载：先只显示 loading，等加载完由下方 watch 补做预填与校验
      if (officialPriceLoading.value) {
        var _thirdPartyPanelRef$v4;
        (_thirdPartyPanelRef$v4 = thirdPartyPanelRef.value) === null || _thirdPartyPanelRef$v4 === void 0 || _thirdPartyPanelRef$v4.clearValidate();
        return;
      }
      if (!xsollaConfig.value.prodPrice) {
        const googleDefaultPrice = getXsollaDefaultPriceFromGoogle();
        if (googleDefaultPrice) {
          xsollaConfig.value = {
            ...xsollaConfig.value,
            prodPrice: googleDefaultPrice
          };
        }
      }
      if (xsollaConfig.value.enableThirdPay && xsollaConfig.value.prodPrice && !((_xsollaConfig$value$p = xsollaConfig.value.prodNativePrices[0]) !== null && _xsollaConfig$value$p !== void 0 && _xsollaConfig$value$p.originProdPrice)) {
        await refreshXsollaRuPrice();
      }
      nextTick(() => {
        var _thirdPartyPanelRef$v6;
        if (!xsollaConfig.value.enableThirdPay || !xsollaConfig.value.prodPrice) {
          var _thirdPartyPanelRef$v5;
          (_thirdPartyPanelRef$v5 = thirdPartyPanelRef.value) === null || _thirdPartyPanelRef$v5 === void 0 || _thirdPartyPanelRef$v5.clearValidate();
          return;
        }
        (_thirdPartyPanelRef$v6 = thirdPartyPanelRef.value) === null || _thirdPartyPanelRef$v6 === void 0 || _thirdPartyPanelRef$v6.validate();
      });
    };
    watch(officialPriceLoading, isLoading => {
      if (!isLoading && priceChannelTab.value === 'xsolla') onPriceChannelTabChange('xsolla');
    });
    const onXsollaEnableChange = async enabled => {
      var _xsollaConfig$value$p2;
      xsollaConfig.value = {
        ...xsollaConfig.value,
        enableThirdPay: enabled
      };
      if (!enabled) return;
      await ensureXsollaRequiredLanguages();
      // 俄罗斯价以默认价为基准，没填默认价时先不请求，避免弹出必填提示
      if (!xsollaConfig.value.prodPrice) return;
      if (!((_xsollaConfig$value$p2 = xsollaConfig.value.prodNativePrices[0]) !== null && _xsollaConfig$value$p2 !== void 0 && _xsollaConfig$value$p2.originProdPrice)) await refreshXsollaRuPrice();
    };
    const onXsollaNativePriceChange = price => {
      xsollaConfig.value = updateXsollaRussiaPrice(xsollaConfig.value, price);
    };
    const onXsollaVatChange = async enabled => {
      xsollaConfig.value = updateXsollaVat(xsollaConfig.value, enabled);
      if (!xsollaConfig.value.enableThirdPay || !xsollaConfig.value.prodPrice) return;
      await refreshXsollaRuPrice();
    };
    const XSOLLA_RUSSIAN_LANGUAGE_CODE = 'ru-RU';
    const XSOLLA_ENGLISH_LANGUAGE_CODE = 'en-US';
    // 自动添加保留俄语+英语，保存校验只强制英语
    const XSOLLA_AUTO_ADD_LANGUAGE_CODES = [XSOLLA_RUSSIAN_LANGUAGE_CODE, XSOLLA_ENGLISH_LANGUAGE_CODE];
    const XSOLLA_REQUIRED_LANGUAGE_CODES = [XSOLLA_ENGLISH_LANGUAGE_CODE];
    const translateXsollaLanguageField = async (sourceItem, targetItem, field) => {
      var _res$data6, _translateList$;
      const sourceText = sourceItem[field];
      if (!sourceText || targetItem[field]) return;
      const translateParams = {
        sourceLang: sourceItem.lang,
        sourceText,
        targetLang: [targetItem.lang]
      };
      const [err, res] = await awaitWrap(translator(translateParams));
      if (err || (res === null || res === void 0 ? void 0 : res.code) !== OK) return;
      const translateList = ((_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.translateList) || [];
      const matchedItem = translateList.find(item => item.lang === targetItem.lang);
      const translatedResult = (matchedItem === null || matchedItem === void 0 ? void 0 : matchedItem.translatedResult) || ((_translateList$ = translateList[0]) === null || _translateList$ === void 0 ? void 0 : _translateList$.translatedResult);
      const targetIndex = settingForm.value.productNativeInfo.findIndex(item => item.lang === targetItem.lang);
      const reactiveTargetItem = settingForm.value.productNativeInfo[targetIndex];
      if (translatedResult && reactiveTargetItem && !reactiveTargetItem[field]) {
        reactiveTargetItem[field] = translatedResult;
      }
    };
    const ensureXsollaRequiredLanguages = async () => {
      const nativeInfos = settingForm.value.productNativeInfo;
      const sourceItem = nativeInfos.find(item => item.lang === settingForm.value.defaultLang);
      for (const [index, languageCode] of XSOLLA_AUTO_ADD_LANGUAGE_CODES.entries()) {
        var _multiComponentRef$va, _multiComponentRef$va2;
        const languageInfo = await ((_multiComponentRef$va = multiComponentRef.value) === null || _multiComponentRef$va === void 0 ? void 0 : _multiComponentRef$va.getLanguageInfo(languageCode));
        if (!languageInfo || nativeInfos.some(item => item.lang === languageInfo.lang)) continue;
        const nativeInfo = {
          key: Date.now() + index,
          lang: languageInfo.lang,
          langName: languageInfo.langName,
          langOptions: [],
          prodName: '',
          prodDescription: ''
        };
        nativeInfos.push(nativeInfo);
        const reactiveNativeInfo = nativeInfos[nativeInfos.length - 1];
        await nextTick();
        (_multiComponentRef$va2 = multiComponentRef.value) === null || _multiComponentRef$va2 === void 0 || _multiComponentRef$va2.refreshLanguageOptions();
        if (!sourceItem || sourceItem.lang === languageInfo.lang) continue;
        await translateXsollaLanguageField(sourceItem, reactiveNativeInfo, 'prodName');
        await translateXsollaLanguageField(sourceItem, reactiveNativeInfo, 'prodDescription');
      }
    };
    const validateXsollaConfig = async () => {
      var _thirdPartyPanelRef$v7, _xsollaNativeRef$valu;
      if (!showXsollaTab.value || !xsollaConfig.value.enableThirdPay) return true;
      const configuredLanguages = new Set(settingForm.value.productNativeInfo.map(item => item.lang));
      const missingLanguageCodes = XSOLLA_REQUIRED_LANGUAGE_CODES.filter(code => !configuredLanguages.has(code));
      if (missingLanguageCodes.length) {
        const missingLanguageNames = await Promise.all(missingLanguageCodes.map(async code => {
          var _multiComponentRef$va3;
          const languageInfo = await ((_multiComponentRef$va3 = multiComponentRef.value) === null || _multiComponentRef$va3 === void 0 ? void 0 : _multiComponentRef$va3.getLanguageInfo(code));
          return (languageInfo === null || languageInfo === void 0 ? void 0 : languageInfo.langName) || code;
        }));
        message.error(`开启 Xsolla 后，商品信息必须包含：${missingLanguageNames.join('、')}`);
        return false;
      }
      if (!isValidXsollaSku(settingForm.value.prodId)) {
        priceChannelTab.value = 'xsolla';
        message.error('Xsolla 内购ID仅支持 1-255 位拉丁字母、数字、点、短横线和下划线');
        return false;
      }
      const priceValid = (_thirdPartyPanelRef$v7 = thirdPartyPanelRef.value) === null || _thirdPartyPanelRef$v7 === void 0 ? void 0 : _thirdPartyPanelRef$v7.validate();
      if (!priceValid) {
        priceChannelTab.value = 'xsolla';
        return false;
      }
      const nativeValid = await ((_xsollaNativeRef$valu = xsollaNativeRef.value) === null || _xsollaNativeRef$valu === void 0 ? void 0 : _xsollaNativeRef$valu.validate());
      if (!nativeValid) {
        priceChannelTab.value = 'xsolla';
        message.error('请填写大于 0 的俄罗斯本地价格');
        return false;
      }
      return true;
    };
    const appendXsollaChannelPrices = params => {
      if (!showXsollaTab.value) return;
      // 新建且未开启三方支付时 xsolla_pay 传 null；编辑仍需传完整结构，否则后端无法感知从开启改为关闭
      if (!queryParams.value.id && !xsollaConfig.value.enableThirdPay) {
        var _params$channelPrices;
        params.channelPrices = {
          ...(params.channelPrices || {}),
          priceInfo: {
            ...(((_params$channelPrices = params.channelPrices) === null || _params$channelPrices === void 0 ? void 0 : _params$channelPrices.priceInfo) || {}),
            xsolla_pay: null
          }
        };
        return;
      }
      const availableTimes = settingForm.value.prodType === '10' ? 1 : undefined;
      // 折扣与 iOS 同口径：基于官方美元价算出的整数百分比，带 % 下发
      const discount = calcDiscountRate(thirdPartyOfficialPrice.value, xsollaConfig.value.prodPrice);
      const configWithDiscount = {
        ...xsollaConfig.value,
        promotionDiscount: discount != null ? `${discount}%` : xsollaConfig.value.promotionDiscount || null
      };
      params.channelPrices = mergeXsollaChannelPrices(params.channelPrices, configWithDiscount, availableTimes);
    };
    const getPkg = async () => {
      loading.value = true;
      const res = await queryPkgInfo({
        dbtId: queryParams.value.dbtId,
        prodChnl: queryParams.value.prodChnl
      });
      typeDisabled.value = false;
      if ((res === null || res === void 0 ? void 0 : res.code) === '0') {
        var _res$data7;
        settingForm.value.pkg = res.data.pkg;
        settingForm.value.prodId = res.data.pkg;
        settingForm.value.defaultLang = res.data.defaultLang;
        settingForm.value.prodPriceCurrency = (_res$data7 = res.data) === null || _res$data7 === void 0 ? void 0 : _res$data7.currency;
        cCountry.value = res.data.country;
      }
      loading.value = false;
    }; //查询包名等信息
    const validateAndHandlePrice = async (price, currency) => {
      try {
        var _priceBlockRef$value3;
        if (!price) {
          message.warning(`请先填写${currency === 'USD' ? '美元' : '默认'}价格`);
          return false;
        }
        if (parseFloat(price) <= 0) {
          return false;
        }
        const flag = await verifyNumber({
          prodChnl: queryParams.value.prodChnl,
          prodPrice: parseFloat(price).toFixed(2),
          prodPriceCurrency: currency,
          prodType: settingForm.value.prodType
        });
        if (!flag) {
          return false;
        }
        priceLoading.value = true;
        let useParams = {
          pkg: settingForm.value.pkg,
          prodChnl: queryParams.value.prodChnl,
          prodPrice: parseFloat(price).toFixed(2),
          prodPriceCurrency: currency,
          prodType: settingForm.value.prodType,
          dbtId: queryParams.value.dbtId
        };
        if (showRateSwitch.value) {
          useParams = Object.assign({}, useParams, {
            applySgtAdjustment: taxRateSwitch.value
          });
        }
        await ((_priceBlockRef$value3 = priceBlockRef.value) === null || _priceBlockRef$value3 === void 0 ? void 0 : _priceBlockRef$value3.queryData(useParams));
        priceLoading.value = false;
        callbackPrice();
        return true;
      } catch (error) {
        console.error('价格处理失败:', error);
        message.error('价格处理失败，请稍后重试');
        return false;
      } finally {
        priceLoading.value = false;
      }
    };
    const getChangePrice = async () => {
      if (timout) {
        clearTimeout(timout);
      }
      const success = await validateAndHandlePrice(settingForm.value.prodPrice, settingForm.value.prodPriceCurrency);
      if (!success) {
        settingForm.value.prodPrice = '';
      }
    };
    // 谷歌层级基准价 → 接口①/保存用 tierPrices（按单一价格流口径：本地价+账户币种，USD 框作辅助；不带 regionCode）
    // 层级基准价统一以 USD 为准（输入框的 USD 值）：接口①查询 + 保存 tierPrices 都用 USD + 输入的 USD 值。
    // 这样落库的就是 USD 原值，回显时用 USD 反查（美国行返回同一 USD，恒等无漂移），
    // 避免"存账号币种(SGD) → 回显用 SGD 反查 USD 对不上"的问题。
    // usd 为空（极少数换算失败）才兜底用账号币种本地价。
    const buildTierPrices = () => {
      var _tierDefaultRef$value5;
      return (((_tierDefaultRef$value5 = tierDefaultRef.value) === null || _tierDefaultRef$value5 === void 0 ? void 0 : _tierDefaultRef$value5.validTiers()) || []).map(t => {
        const useUsd = settingForm.value.prodPriceCurrency === 'USD' || !!t.usd;
        return {
          tierCode: t.tierCode,
          prodPrice: useUsd ? t.usd : t.localPrice,
          prodPriceCurrency: useUsd ? 'USD' : settingForm.value.prodPriceCurrency,
          regionCode: '',
          priceId: '',
          priceTier: ''
        };
      });
    };
    // 是否已为本次新建回填过层级模板（避免重复回填/死循环）
    const tierTemplateApplied = ref(false);
    // 切到分层模式时拉到的国家-层级模板，待本地价表生成后回填一次
    const pendingTemplateMappings = ref(null);
    // 编辑态首次回显中：抑制接口①（本地价直接取 productNativePrice）；回显完成后照常重算
    const tieredRestoring = ref(false);
    // 调接口①生成本地价（SG 商户开 GST 调价时下发 applySgtAdjustment）。
    // 新建场景：先把模板映射记进组件（按有效层级/手动覆盖在 generate 时渐进生效），
    // 待首次拿到国家全集后再生成一次，让模板对应层级的国家按其层级算价。
    const runGenerateTiered = async () => {
      var _pendingTemplateMappi, _tierLocalRef$value4, _pendingTemplateMappi2, _tierLocalRef$value5;
      const gst = showRateSwitch.value ? taxRateSwitch.value : undefined;
      if (isNewGoods.value && !tierTemplateApplied.value && (((_pendingTemplateMappi = pendingTemplateMappings.value) === null || _pendingTemplateMappi === void 0 ? void 0 : _pendingTemplateMappi.length) || 0) > 0) {
        var _tierLocalRef$value3;
        (_tierLocalRef$value3 = tierLocalRef.value) === null || _tierLocalRef$value3 === void 0 || _tierLocalRef$value3.applyTemplateMappings(pendingTemplateMappings.value);
      }
      await ((_tierLocalRef$value4 = tierLocalRef.value) === null || _tierLocalRef$value4 === void 0 ? void 0 : _tierLocalRef$value4.generate(buildTierPrices(), gst));
      if (isNewGoods.value && !tierTemplateApplied.value && (((_pendingTemplateMappi2 = pendingTemplateMappings.value) === null || _pendingTemplateMappi2 === void 0 ? void 0 : _pendingTemplateMappi2.length) || 0) > 0 && (((_tierLocalRef$value5 = tierLocalRef.value) === null || _tierLocalRef$value5 === void 0 || (_tierLocalRef$value5 = _tierLocalRef$value5.list) === null || _tierLocalRef$value5 === void 0 ? void 0 : _tierLocalRef$value5.length) || 0) > 0) {
        var _tierLocalRef$value6;
        tierTemplateApplied.value = true;
        await ((_tierLocalRef$value6 = tierLocalRef.value) === null || _tierLocalRef$value6 === void 0 ? void 0 : _tierLocalRef$value6.generate(buildTierPrices(), gst));
      }
    };
    // 防抖：层级默认价/国家映射/GST 变化 → 重新调接口①生成全表
    // 编辑态首次回显期间跳过，避免覆盖 productNativePrice 回显的本地价
    let tierGenTimer = null;
    const regenerateTiered = () => {
      if (tieredRestoring.value) return;
      if (tierGenTimer) clearTimeout(tierGenTimer);
      tierGenTimer = setTimeout(runGenerateTiered, 800);
    };
    // 层级默认价改动（改价/填价/清空价/删层级，均由 TierDefaultPrice emit 携带层级码）→ 是否重算本地价（接口①）：
    // T1 全局兜底层级（或苹果选基准国价无层级码）改动必重算；
    // 其余层级仅当该层级有国家归属（当前/模板/手动）时才重算，无国家的层级变动不影响接口输出，跳过
    const onTierDefaultPriceChange = tierCode => {
      var _tierLocalRef$value7;
      if (!tierCode || tierCode === 'T1') {
        regenerateTiered();
        return;
      }
      if ((_tierLocalRef$value7 = tierLocalRef.value) !== null && _tierLocalRef$value7 !== void 0 && _tierLocalRef$value7.hasCountriesInTier(tierCode)) {
        regenerateTiered();
      }
    };
    // 谷歌分层基准价 USD ⇄ 账号币种换算：复用单一价格的 queryPriceList，
    // 取美国行(USD)/账号币种对应国家行(本地价) 回填另一币种框，再触发本地价表重算。
    // 与单一模式 getPriceByUsd/callbackPrice 同口径：开 GST 时本地价取税前 originProdPrice。
    const convertTierAmount = async (tier, from, echo = false) => {
      const srcVal = from === 'usd' ? tier.usd : tier.localPrice;
      const srcCurrency = from === 'usd' ? 'USD' : settingForm.value.prodPriceCurrency;
      const targetField = from === 'usd' ? 'localPrice' : 'usd';
      // 源值为空/非法 → 清空另一币种框，避免残留旧换算值（回显信任已存值，不清空）
      if (!srcVal || parseFloat(srcVal) <= 0) {
        if (!echo) tier[targetField] = '';
        return;
      }
      // 回显信任已保存值，跳过 verifyNumber，避免误判清掉存量数据
      if (!echo) {
        const flag = await verifyNumber({
          prodChnl: queryParams.value.prodChnl,
          prodPrice: parseFloat(srcVal).toFixed(2),
          prodPriceCurrency: srcCurrency,
          prodType: settingForm.value.prodType
        });
        if (!flag) {
          tier[from] = '';
          tier[targetField] = '';
          return;
        }
      }
      let params = {
        pkg: settingForm.value.pkg,
        prodChnl: queryParams.value.prodChnl,
        prodPrice: parseFloat(srcVal).toFixed(2),
        prodPriceCurrency: srcCurrency,
        prodType: settingForm.value.prodType,
        dbtId: queryParams.value.dbtId
      };
      if (showRateSwitch.value) {
        params = Object.assign({}, params, {
          applySgtAdjustment: taxRateSwitch.value
        });
      }
      priceLoading.value = true;
      try {
        var _res$data8, _priceList$find, _priceList$find2;
        const res = await queryPriceList(params);
        if ((res === null || res === void 0 ? void 0 : res.code) !== '0') return;
        const priceList = (res === null || res === void 0 || (_res$data8 = res.data) === null || _res$data8 === void 0 ? void 0 : _res$data8.productNativePrice) || [];
        // 与单一模式 callbackPrice 同口径：同一次响应里把基准价两个框都回填——
        // USD 框取美国行 prodPrice（不受 GST 影响）；账号币种框取对应国家行（开 GST 用税前 originProdPrice）
        const priceField = showRateSwitch.value ? 'originProdPrice' : 'prodPrice';
        const localCountry = prodPriceCurrencyObj[settingForm.value.prodPriceCurrency];
        const usdFromRes = (_priceList$find = priceList.find(it => it.regionName === '美国')) === null || _priceList$find === void 0 ? void 0 : _priceList$find.prodPrice;
        const localFromRes = (_priceList$find2 = priceList.find(it => it.regionName === localCountry)) === null || _priceList$find2 === void 0 ? void 0 : _priceList$find2[priceField];
        tier.usd = usdFromRes !== null && usdFromRes !== void 0 ? usdFromRes : tier.usd;
        tier.localPrice = localFromRes !== null && localFromRes !== void 0 ? localFromRes : tier.localPrice;
      } finally {
        priceLoading.value = false;
      }
    };
    // 谷歌分层金额框失焦：换算回填另一币种，按层级触发本地价表重算
    const onGoogleTierConvert = async ({
      tier,
      from
    }) => {
      // 等换算回填完 USD 框再往下走：T1 的 USD 值就是三方支付的官方价基准
      await convertTierAmount(tier, from);
      onTierDefaultPriceChange(tier.tierCode);
    };
    // 用户切到分层模式：立即拉取国家-层级模板（新建场景），再触发一次生成（回显走 getDetail，不经此处）
    const onPriceModeChange = async e => {
      var _e$target;
      if ((e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value) === 'tiered') {
        var _tierLocalRef$value8;
        // 已有分层数据（编辑回显或之前已配置）→ 切回时保留，不重新生成覆盖已填/已改的本地价
        if ((((_tierLocalRef$value8 = tierLocalRef.value) === null || _tierLocalRef$value8 === void 0 || (_tierLocalRef$value8 = _tierLocalRef$value8.list) === null || _tierLocalRef$value8 === void 0 ? void 0 : _tierLocalRef$value8.length) || 0) > 0) return;
        tierTemplateApplied.value = false;
        pendingTemplateMappings.value = null;
        if (isNewGoods.value) {
          pendingTemplateMappings.value = await fetchTierTemplateMappings({
            dbtId: queryParams.value.dbtId,
            prodChnl: queryParams.value.prodChnl,
            prodType: settingForm.value.prodType
          });
        }
        nextTick(runGenerateTiered);
      }
    };
    // 单一模式重算价表：非 USD 账号统一以 USD 框为基准（prodPriceCurrency=USD），
    // USD 账号用默认价框。GST 切换、刷新价表等所有重算入口共用，保证基准币种一致、不漂移。
    const recalcSinglePrice = () => {
      if (settingForm.value.prodPriceCurrency !== 'USD') {
        getPriceByUsd();
      } else {
        getChangePrice();
      }
    };
    // GST 调价：单一模式重算价格；分层模式作为 applySgtAdjustment 入参交接口①重算
    const onGstChange = () => {
      if (priceMode.value === 'tiered') {
        regenerateTiered();
        return;
      }
      recalcSinglePrice();
    };
    // 点击文字区域切换 GST 开关（与开关同效）
    const onGstClick = () => {
      if (rateSwitchStatus.value || priceLoading.value) return;
      taxRateSwitch.value = !taxRateSwitch.value;
      onGstChange();
    };
    // 分层定价商品信息校验（名称/描述；价格取本地价格表）
    const checkerTiered = () => {
      var _tierLocalRef$value9;
      for (let i = 0; i < settingForm.value.productNativeInfo.length; i++) {
        const item = settingForm.value.productNativeInfo[i];
        if (!item.lang || !item.prodDescription || !item.prodName) {
          message.error('商品信息的语言，商品名称，商品描述需要正确填写完整');
          return false;
        }
      }
      const rows = ((_tierLocalRef$value9 = tierLocalRef.value) === null || _tierLocalRef$value9 === void 0 ? void 0 : _tierLocalRef$value9.list) || [];
      if (!rows.length) {
        message.error('请先填写层级默认价生成本地价格');
        return false;
      }
      for (let i = 0; i < rows.length; i++) {
        if (!rows[i].prodPrice) {
          message.error('价格信息内容请填写完整');
          return false;
        }
      }
      return true;
    };
    // 分层定价保存：基础校验 → 层级默认价校验 → 检出空置层级 → 弹窗确认 / 直接提交
    const handleTieredSave = async () => {
      var _tierDefaultRef$value6, _tierDefaultRef$value7, _tierLocalRef$value10;
      try {
        await myFormRef.value.validate();
      } catch {
        return;
      }
      if (!checkerTiered()) return;
      if (!(await validateXsollaConfig())) return;
      if (!((_tierDefaultRef$value6 = tierDefaultRef.value) !== null && _tierDefaultRef$value6 !== void 0 && _tierDefaultRef$value6.validate())) {
        message.error('请完整填写层级默认价（T1 必填）');
        return;
      }
      // 两种定价模式都有完整价格时才提示当前保存模式；确认后继续空置层级校验/提交
      if (shouldConfirmPriceMode() && !modeConfirmed.value) {
        priceModeConfirmOpen.value = true;
        return;
      }
      modeConfirmed.value = false;
      const validCodes = (((_tierDefaultRef$value7 = tierDefaultRef.value) === null || _tierDefaultRef$value7 === void 0 ? void 0 : _tierDefaultRef$value7.validTiers()) || []).map(t => t.tierCode);
      const mappings = ((_tierLocalRef$value10 = tierLocalRef.value) === null || _tierLocalRef$value10 === void 0 ? void 0 : _tierLocalRef$value10.getCountryTierMappings()) || [];
      const unused = getUnusedTiers(validCodes, mappings);
      if (unused.length) {
        unusedTiers.value = unused;
        unusedModalOpen.value = true;
        return;
      }
      await submitTiered();
    };
    // 组装并提交分层定价商品（并入 addGoods/updGoods，bizInfo.tieredPricing 承载层级配置）
    const submitTiered = async (excludeTierCodes = []) => {
      tieredSaving.value = true;
      try {
        var _tierLocalRef$value11, _tierLocalRef$value12;
        // 保存的国家映射含 T1 国家（后端需显式落库）；接口①/空置层级校验仍用不含 T1 的 getCountryTierMappings
        const countryTierMappings = ((_tierLocalRef$value11 = tierLocalRef.value) === null || _tierLocalRef$value11 === void 0 ? void 0 : _tierLocalRef$value11.getCountryTierMappingsForSave()) || [];
        // tierPrices 由 countryTierMappings 反推：没有任何国家归属的层级（如设了 T3 价但无 T3 国家）不下发，
        // 与接口① generate 同口径；excludeTierCodes 来自空置层级弹窗的二次确认。
        const tierPrices = filterUsedTierPrices(buildTierPrices(), countryTierMappings).filter(tp => !excludeTierCodes.includes(tp.tierCode));
        handleSaveParams();
        // 顶层默认价按 T1 层级铺设，与单一价格流入参口径一致（其余必填值取 T1）
        const t1 = tierPrices.find(t => t.tierCode === 'T1');
        const params = {
          ...settingForm.value,
          prodChnl: queryParams.value.prodChnl,
          dbtId: queryParams.value.dbtId,
          prodPrice: (t1 === null || t1 === void 0 ? void 0 : t1.prodPrice) || '',
          prodPriceCurrency: (t1 === null || t1 === void 0 ? void 0 : t1.prodPriceCurrency) || settingForm.value.prodPriceCurrency,
          productNativePrice: ((_tierLocalRef$value12 = tierLocalRef.value) === null || _tierLocalRef$value12 === void 0 ? void 0 : _tierLocalRef$value12.getNativePrices()) || []
        };
        params.bizInfo = {
          ...(settingForm.value.bizInfo || {}),
          tieredPricing: buildTieredPricing({
            tierPrices,
            countryTierMappings,
            saveAsTemplate: tierTemplateEnabled.value
          })
        };
        // SG 商户：分层模式也携带 GST 调价开关（与单一模式一致）
        if (showRateSwitch.value) {
          params.bizInfo.sgtPriceAdjustment = {
            enabled: taxRateSwitch.value
          };
        }
        if (['10', '20'].includes(settingForm.value.prodType)) {
          const googleRentalConfig = {
            purchaseType: settingForm.value.purchaseType,
            rentalPeriod: settingForm.value.rentalPeriod
          };
          if (settingForm.value.prodType === '10') delete googleRentalConfig.rentalPeriod;
          params.bizInfo.googleRentalConfig = googleRentalConfig;
        }
        appendXsollaChannelPrices(params);
        if (params.pkg === params.prodId) {
          message.error('内购ID不可完全等于包名，请手动补齐内购ID后半部分');
          return;
        }
        const fn = queryParams.value.id ? updGoods : addGoods;
        const res = await fn(params);
        if (res.code === '0') {
          message.success('商品保存成功！');
          reportEvent({
            eventName: 'element_use',
            properties: {
              ui_name: '谷歌商品配置',
              element_name: '保存'
            }
          });
          if (!saveNext.value) {
            router.push({
              name: 'goodsSetting'
            });
          } else {
            var _priceBlockRef$value4, _tierDefaultRef$value8, _tierLocalRef$value13;
            // 连续创建：留在本页清空配置，保留分层定价模式，重置层级默认价与本地价格表
            settingForm.value = {
              ...cloneDeep(detailFormInit),
              prodPriceCurrency: settingForm.value.prodPriceCurrency,
              prodType: settingForm.value.prodType,
              pkg: settingForm.value.pkg,
              productNativeInfo: settingForm.value.productNativeInfo.map(item => ({
                ...item,
                prodDescription: '',
                prodName: ''
              }))
            };
            (_priceBlockRef$value4 = priceBlockRef.value) === null || _priceBlockRef$value4 === void 0 || _priceBlockRef$value4.reset();
            resetManualProdId();
            changeProdType();
            // 分层专属：重置层级默认价 + 本地价格表（含手动/模板映射），避免上一个商品配置残留
            (_tierDefaultRef$value8 = tierDefaultRef.value) === null || _tierDefaultRef$value8 === void 0 || _tierDefaultRef$value8.reset();
            (_tierLocalRef$value13 = tierLocalRef.value) === null || _tierLocalRef$value13 === void 0 || _tierLocalRef$value13.reset();
            tierTemplateEnabled.value = true;
            tierTemplateApplied.value = false;
            pendingTemplateMappings.value = null;
          }
        } else {}
      } catch (error) {} finally {
        tieredSaving.value = false;
        unusedModalOpen.value = false;
      }
    };
    // 弹窗【确认并保存】：移除空置层级后提交
    const onUnusedConfirm = () => {
      submitTiered(unusedTiers.value);
    };
    // 弹窗【取消并去分配】：关闭回页面，不保存
    const onUnusedCancel = () => {
      unusedModalOpen.value = false;
    };
    const getPriceByUsd = async () => {
      if (timout) {
        clearTimeout(timout);
      }
      const success = await validateAndHandlePrice(originUsdPrice.value, 'USD');
      if (!success) {
        originUsdPrice.value = '';
      }
    };
    const changeProdPrice = () => {
      // 节流
      if (timout) {
        clearTimeout(timout);
      }
      timout = setTimeout(async () => {
        // 刷新价表：与 GST 重算同口径，非 USD 账号以 USD 框为基准，避免用账号币种重算
        recalcSinglePrice();
      }, 800);
    }; // 变更默认价格需要重新请求价目表
    const prodPriceCurrencyObj = {
      USD: '美国',
      HKD: '香港',
      SGD: '新加坡'
    };
    const callbackPrice = () => {
      var _priceBlockRef$value5;
      // 渠道是google且默认币种是SGD时，使用originProdPrice
      const priceField = showRateSwitch.value ? 'originProdPrice' : 'prodPrice';
      settingForm.value.prodPrice = (_priceBlockRef$value5 = priceBlockRef.value) === null || _priceBlockRef$value5 === void 0 || (_priceBlockRef$value5 = _priceBlockRef$value5.originData.filter(item => {
        return item.regionName === prodPriceCurrencyObj[settingForm.value.prodPriceCurrency];
      })) === null || _priceBlockRef$value5 === void 0 || (_priceBlockRef$value5 = _priceBlockRef$value5[0]) === null || _priceBlockRef$value5 === void 0 ? void 0 : _priceBlockRef$value5[priceField];
      if (settingForm.value.prodPriceCurrency !== 'USD') {
        var _priceBlockRef$value6;
        originUsdPrice.value = (_priceBlockRef$value6 = priceBlockRef.value) === null || _priceBlockRef$value6 === void 0 || (_priceBlockRef$value6 = _priceBlockRef$value6.originData.filter(item => {
          return item.regionName === '美国';
        })) === null || _priceBlockRef$value6 === void 0 || (_priceBlockRef$value6 = _priceBlockRef$value6[0]) === null || _priceBlockRef$value6 === void 0 ? void 0 : _priceBlockRef$value6.prodPrice;
      }
    }; // 价格列表回调
    const cancel = () => {
      window.history.go(-1);
    }; // 取消逻辑
    const setProdId = e => {
      e = e.trim();
      if (queryParams.value.id) return; // 编辑时不允许修改内购ID
      if (isManualProdId.value) return; // 用户主动修改过，后面就不自动根据商品信息拼接
      let pkgStr = settingForm.value.pkg; // 拼接前缀
      let lengthLimit = 140; // 最大字符数
      if (['31', '32'].includes(settingForm.value.prodType)) {
        // 订阅非订阅类需要调整字符数和拼接pkg的内容
        pkgStr = settingForm.value.pkg.split('.').map(item => item[0]).join('.');
        lengthLimit = 40;
      }
      if (!e.length) {
        // 值为空的时候赋值为包名
        settingForm.value.prodId = pkgStr;
        return;
      }
      try {
        var _getStr$match;
        let getStr = e.toLowerCase().replace(/\s*/g, '');
        getStr = ((_getStr$match = getStr.match(/[a-z0-9.]/g)) === null || _getStr$match === void 0 ? void 0 : _getStr$match.join('')) || '';
        const countStr = lengthLimit - pkgStr.length - 1;
        settingForm.value.prodId = pkgStr + '.' + getStr.slice(0, countStr);
      } catch (error) {}
      myFormRef.value.validate();
    }; // 根据商品名/订阅名，内购ID自动拼接
    const changeProdType = () => {
      var _tierDefaultRef$value9, _tierLocalRef$value14;
      priceChannelTab.value = 'google';
      xsollaConfig.value = createDefaultXsollaPayInfo();
      xsollaPriceLoading.value = false;
      priceMode.value = 'single';
      // 分层组件改用 v-show 常驻后切类型不再卸载，需主动重置，避免上一个类型的层级默认价/本地价残留
      (_tierDefaultRef$value9 = tierDefaultRef.value) === null || _tierDefaultRef$value9 === void 0 || _tierDefaultRef$value9.reset();
      (_tierLocalRef$value14 = tierLocalRef.value) === null || _tierLocalRef$value14 === void 0 || _tierLocalRef$value14.reset();
      tierTemplateEnabled.value = true;
      tierTemplateApplied.value = false;
      pendingTemplateMappings.value = null;
      nextTick(() => {
        var _settingForm$value2;
        setProdId((_settingForm$value2 = settingForm.value) === null || _settingForm$value2 === void 0 || (_settingForm$value2 = _settingForm$value2.productNativeInfo[0]) === null || _settingForm$value2 === void 0 ? void 0 : _settingForm$value2.prodName);
      });
      // 如果是非消耗型-购买状态设置为购买
      if (settingForm.value.prodType == '10') {
        settingForm.value.purchaseType = 'buy';
      }
    }; // 变更商品类型需要注意内购ID重新组合
    const checker = () => {
      var _priceBlockRef$value7;
      for (let i = 0; i < settingForm.value.productNativeInfo.length; i++) {
        const item = settingForm.value.productNativeInfo[i];
        if (!item.lang || !item.prodDescription || !item.prodName) {
          message.error('商品信息的语言，商品名称，商品描述需要正确填写完整');
          return false;
        }
        if (settingForm.value.prodType === '31' || settingForm.value.prodType === '32') {
          var _item$prodName, _item$prodDescription, _item$prodName2, _item$prodDescription2;
          if (((_item$prodName = item.prodName) === null || _item$prodName === void 0 ? void 0 : _item$prodName.length) > 55) {
            item.error = '商品名称不能超过55个字符';
          }
          if (((_item$prodDescription = item.prodDescription) === null || _item$prodDescription === void 0 ? void 0 : _item$prodDescription.length) > 40) {
            item.error = '商品描述不能超过40个字符';
          }
          if (((_item$prodName2 = item.prodName) === null || _item$prodName2 === void 0 ? void 0 : _item$prodName2.length) <= 55 && ((_item$prodDescription2 = item.prodDescription) === null || _item$prodDescription2 === void 0 ? void 0 : _item$prodDescription2.length) <= 40) {
            item.error = '';
          }
        } else {
          var _item$prodName3, _item$prodDescription3, _item$prodName4, _item$prodDescription4;
          if (((_item$prodName3 = item.prodName) === null || _item$prodName3 === void 0 ? void 0 : _item$prodName3.length) > 55) {
            item.error = '商品名称不能超过55个字符';
          }
          if (((_item$prodDescription3 = item.prodDescription) === null || _item$prodDescription3 === void 0 ? void 0 : _item$prodDescription3.length) > 200) {
            item.error = '商品描述不能超过200个字符';
          }
          if (((_item$prodName4 = item.prodName) === null || _item$prodName4 === void 0 ? void 0 : _item$prodName4.length) <= 55 && ((_item$prodDescription4 = item.prodDescription) === null || _item$prodDescription4 === void 0 ? void 0 : _item$prodDescription4.length) <= 200) {
            item.error = '';
          }
        }
      } // 商品信息校验
      if (settingForm.value.productNativeInfo.filter(item => item.error).length) {
        return false;
      }
      const getPriceArr = (_priceBlockRef$value7 = priceBlockRef.value) === null || _priceBlockRef$value7 === void 0 ? void 0 : _priceBlockRef$value7.originData;
      if (!getPriceArr.length) {
        message.error('价格信息表内容不能为空');
        return false;
      } else {
        for (let i = 0; i < getPriceArr.length; i++) {
          const item = getPriceArr[i];
          if (!item.prodPrice) {
            message.error('价格信息内容请填写完整');
            return false;
          }
        } // 价格信息校验
      }
      return true;
    }; // 自定义部分校验
    const handleSaveParams = () => {
      if (settingForm.value.prodType === '31') {
        var _settingForm$value3, _settingForm$value4, _settingForm$value5;
        delete settingForm.value.prodGracePlan;
        settingForm.value.prodBasePlan = {
          planDuration: (_settingForm$value3 = settingForm.value) === null || _settingForm$value3 === void 0 || (_settingForm$value3 = _settingForm$value3.prodBasePlan) === null || _settingForm$value3 === void 0 ? void 0 : _settingForm$value3.planDuration,
          timeExtension: (_settingForm$value4 = settingForm.value) === null || _settingForm$value4 === void 0 || (_settingForm$value4 = _settingForm$value4.prodBasePlan) === null || _settingForm$value4 === void 0 ? void 0 : _settingForm$value4.timeExtension,
          id: (_settingForm$value5 = settingForm.value) === null || _settingForm$value5 === void 0 || (_settingForm$value5 = _settingForm$value5.prodBasePlan) === null || _settingForm$value5 === void 0 ? void 0 : _settingForm$value5.id
        };
      } else if (settingForm.value.prodType === '32') {
        var _settingForm$value6, _settingForm$value7;
        (_settingForm$value6 = settingForm.value) === null || _settingForm$value6 === void 0 || (_settingForm$value6 = _settingForm$value6.prodBasePlan) === null || _settingForm$value6 === void 0 || delete _settingForm$value6.planDuration;
        (_settingForm$value7 = settingForm.value) === null || _settingForm$value7 === void 0 || (_settingForm$value7 = _settingForm$value7.prodBasePlan) === null || _settingForm$value7 === void 0 || delete _settingForm$value7.timeExtension;
      } else {
        delete settingForm.value.prodBasePlan;
        delete settingForm.value.prodGracePlan;
      }
    }; // 提交前根据商品类型处理多余结构
    // 保存二次确认：先弹定价模式确认，确认后再执行实际保存
    const priceModeConfirmOpen = ref(false);
    const hasPriceRows = (prices = []) => prices.length > 0;
    const shouldConfirmPriceMode = () => {
      var _priceBlockRef$value8, _tierDefaultRef$value10, _tierLocalRef$value15;
      const hasSinglePrice = !!settingForm.value.prodPrice && hasPriceRows((_priceBlockRef$value8 = priceBlockRef.value) === null || _priceBlockRef$value8 === void 0 ? void 0 : _priceBlockRef$value8.originData);
      const hasTieredPrice = !!((_tierDefaultRef$value10 = tierDefaultRef.value) !== null && _tierDefaultRef$value10 !== void 0 && _tierDefaultRef$value10.validate()) && hasPriceRows((_tierLocalRef$value15 = tierLocalRef.value) === null || _tierLocalRef$value15 === void 0 ? void 0 : _tierLocalRef$value15.list);
      return hasSinglePrice && hasTieredPrice;
    };
    // 定价模式二次确认：复用 doSave/handleTieredSave 里已有的校验，不再单独抄一遍——
    // save 直接走 doSave，校验通过、真正提交前才弹此框；确认后置 modeConfirmed 再走一次 doSave 直接提交。
    const modeConfirmed = ref(false);
    const save = () => {
      modeConfirmed.value = false;
      doSave();
    };
    const onPriceModeConfirm = () => {
      priceModeConfirmOpen.value = false;
      modeConfirmed.value = true;
      doSave();
    };
    const onPriceModeConfirmCancel = () => {
      priceModeConfirmOpen.value = false;
    };
    const doSave = async () => {
      // 多默认价格（分层定价）保存流程
      if (priceMode.value === 'tiered') {
        await handleTieredSave();
        return;
      }
      myFormRef.value.validate().then(async valid => {
        try {
          if (valid) {
            var _priceBlockRef$value9, _params$bizInfo;
            if (!checker()) return;
            if (!(await validateXsollaConfig())) return;
            // 两种定价模式都有完整价格时才提示当前保存模式；确认后再走到这里直接提交
            if (shouldConfirmPriceMode() && !modeConfirmed.value) {
              priceModeConfirmOpen.value = true;
              return;
            }
            modeConfirmed.value = false;
            const fn = queryParams.value.id ? updGoods : addGoods;
            handleSaveParams();
            let params = {
              ...settingForm.value,
              prodChnl: queryParams.value.prodChnl,
              dbtId: queryParams.value.dbtId,
              productNativePrice: (_priceBlockRef$value9 = priceBlockRef.value) === null || _priceBlockRef$value9 === void 0 ? void 0 : _priceBlockRef$value9.originData
            };
            // 单一价格保存：按单一价格的数据结构提交，剔除可能残留的多默认价配置
            // （编辑态从多默认价切回单一时，settingForm.bizInfo 仍带着回显的 tieredPricing）
            if ((_params$bizInfo = params.bizInfo) !== null && _params$bizInfo !== void 0 && _params$bizInfo.tieredPricing) {
              delete params.bizInfo.tieredPricing;
            }
            // 渠道谷歌+默认币种是SGD则增加参数
            if (showRateSwitch.value) {
              params = Object.assign({}, params, {
                bizInfo: {
                  sgtPriceAdjustment: {
                    enabled: taxRateSwitch.value
                  }
                }
              });
            }
            if (settingForm.value.prodType === '32' && discountPlanRef.value.checkOut()) {
              var _discountPlanRef$valu, _discountPlanRef$valu2, _settingForm$value8;
              params = {
                ...params,
                prodGracePlan: (_discountPlanRef$valu = discountPlanRef.value) !== null && _discountPlanRef$valu !== void 0 && _discountPlanRef$valu.handleData() ? {
                  ...((_discountPlanRef$valu2 = discountPlanRef.value) === null || _discountPlanRef$valu2 === void 0 ? void 0 : _discountPlanRef$valu2.handleData()),
                  id: (_settingForm$value8 = settingForm.value) === null || _settingForm$value8 === void 0 || (_settingForm$value8 = _settingForm$value8.prodGracePlan) === null || _settingForm$value8 === void 0 ? void 0 : _settingForm$value8.id
                } : null
              };
            } else if (settingForm.value.prodType === '32' && !discountPlanRef.value.checkOut()) {
              return params.prodGracePlan = null;
            }
            if (params.pkg === params.prodId) {
              return message.error('内购ID不可完全等于包名，请手动补齐内购ID后半部分');
            }
            // 消耗性和非消耗性需要增加入参bizInfo
            if (['10', '20'].includes(settingForm.value.prodType)) {
              // 谷歌新增购买类型参数
              const googleRentalConfig = {
                purchaseType: settingForm.value.purchaseType,
                rentalPeriod: settingForm.value.rentalPeriod // 仅rent时需要
              };
              // 非消耗型去掉租赁值
              if (settingForm.value.prodType === '10') {
                delete googleRentalConfig.rentalPeriod;
              }
              params.bizInfo = Object.assign(params.bizInfo || {}, {
                googleRentalConfig
              });
            }
            appendXsollaChannelPrices(params);
            saveLoading.value = true;
            const res = await fn(params);
            saveLoading.value = false;
            if (res.code === '0') {
              message.success('商品保存成功！');
              if (!saveNext.value) {
                router.push({
                  name: 'goodsSetting'
                });
              } else {
                var _priceBlockRef$value10;
                settingForm.value = {
                  ...cloneDeep(detailFormInit),
                  prodPriceCurrency: settingForm.value.prodPriceCurrency,
                  prodType: settingForm.value.prodType,
                  pkg: settingForm.value.pkg,
                  productNativeInfo: settingForm.value.productNativeInfo.map(item => {
                    return {
                      ...item,
                      prodDescription: '',
                      prodName: ''
                    };
                  })
                };
                (_priceBlockRef$value10 = priceBlockRef.value) === null || _priceBlockRef$value10 === void 0 || _priceBlockRef$value10.reset();
                resetManualProdId();
                changeProdType();
              }
              reportEvent({
                eventName: 'element_use',
                properties: {
                  ui_name: '谷歌商品配置',
                  element_name: '保存'
                }
              });
            } else {}
          }
        } catch (error) {}
      });
    }; // 保存逻辑
    const queryLastLangInfo = async () => {
      const [err, res] = await awaitWrap(getLastLangInfo({
        dbtId: queryParams.value.dbtId,
        prodChnl: queryParams.value.prodChnl
      }));
      if (err) return void 0;
      if (res && res.code === OK) {
        var _res$data9, _res$data10;
        if (((_res$data9 = res.data) === null || _res$data9 === void 0 || (_res$data9 = _res$data9.lastLangInfos) === null || _res$data9 === void 0 ? void 0 : _res$data9.length) <= 1) return showLastLangInfo.value = false;
        showLastLangInfo.value = true;
        lastLangInfo.value = (_res$data10 = res.data) === null || _res$data10 === void 0 || (_res$data10 = _res$data10.lastLangInfos) === null || _res$data10 === void 0 ? void 0 : _res$data10.map(item => {
          return {
            ...item,
            prodDescription: '',
            prodName: ''
          };
        });
      } else {
        message.error(res.msg);
      }
    }; // 查询历史语言信息
    const changeLastLangInfo = async () => {
      // 找到默认语言对应的项
      const defaultLangItem = settingForm.value.productNativeInfo.find(item => item.lang === settingForm.value.defaultLang);
      // 保存默认语言的 prodDescription 和 prodName（如果有填写）
      const savedProdDescription = (defaultLangItem === null || defaultLangItem === void 0 ? void 0 : defaultLangItem.prodDescription) || '';
      const savedProdName = (defaultLangItem === null || defaultLangItem === void 0 ? void 0 : defaultLangItem.prodName) || '';
      settingForm.value.productNativeInfo = cloneDeep(lastLangInfo.value);
      // 如果默认语言有填写内容，则恢复到新数组中对应的语言项
      if ((savedProdDescription || savedProdName) && settingForm.value.defaultLang) {
        const targetIndex = settingForm.value.productNativeInfo.findIndex(item => item.lang === settingForm.value.defaultLang);
        if (targetIndex !== -1) {
          settingForm.value.productNativeInfo[targetIndex].prodDescription = savedProdDescription;
          settingForm.value.productNativeInfo[targetIndex].prodName = savedProdName;
        }
      }
      if (xsollaConfig.value.enableThirdPay) await ensureXsollaRequiredLanguages();
    }; // 修改历史语言信息
    const showRateSwitch = computed(() => {
      return cCountry.value == 'SG' && queryParams.value.prodChnl == 'google';
    }); // 渠道谷歌+默认币种是SGD则暂时税率开关
    const rateSwitchStatus = computed(() => {
      return queryParams.value.type === 'watch';
    }); // 详情时无法编辑税率开关
    onMounted(async () => {
      queryParams.value = {
        ...route.query
      };
      if (route.query.type === 'watch') {
        disabled.value = true;
      }
      // 编辑/查看：详情还没开始请求前就标记加载中，避免先点三方页签时用空官方价校验
      if (route.query.id) detailLoading.value = true;
      await getCountryCoinOptions();
      await getPkg();
      await queryLastLangInfo();
      if (queryParams.value.id) {
        getDetail();
      }
    });
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_skeleton_button = _resolveComponent("a-skeleton-button");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_segmented = _resolveComponent("a-segmented");
      const _component_a_radio = _resolveComponent("a-radio");
      const _component_a_tag = _resolveComponent("a-tag");
      const _component_a_radio_group = _resolveComponent("a-radio-group");
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_SvgIcon = _resolveComponent("SvgIcon");
      const _component_a_switch = _resolveComponent("a-switch");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_spin = _resolveComponent("a-spin");
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        ref_key: "myFormRef",
        ref: myFormRef,
        model: settingForm.value,
        "label-col": {
          style: 'width: 100px'
        },
        autocomplete: "off"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [queryParams.value.id ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_a_button, {
          onClick: _cache[0] || (_cache[0] = () => {
            _unref(router).back();
          })
        }, {
          default: _withCtx(() => [_createTextVNode(" 返回 ")]),
          _: 1
        }), _createElementVNode("div", {
          class: "record-text",
          onClick: _cache[1] || (_cache[1] = $event => recordVisible.value = true)
        }, "变更记录")])) : _createCommentVNode("", true), _hoisted_4, _createVNode(_component_a_form_item, {
          label: "商品类型",
          name: "prodType",
          rules: [{
            required: true,
            type: 'string'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            class: "inputer",
            value: settingForm.value.prodType,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => settingForm.value.prodType = $event),
            options: _unref(prodTypeOptions),
            disabled: typeDisabled.value || disabled.value || !!queryParams.value.id,
            onChange: changeProdType,
            getPopupContainer: _unref(getNode)
          }, {
            option: _withCtx(({
              label,
              describtion
            }) => [_createElementVNode("div", _hoisted_5, _toDisplayString(label), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(describtion), 1)]),
            _: 1
          }, 8, ["value", "options", "disabled", "getPopupContainer"])]),
          _: 1
        }), ['20', '10'].includes(settingForm.value.prodType) ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 1,
          label: "购买类型",
          name: "purchaseType",
          rules: [{
            required: true,
            message: '请选择购买类型',
            type: 'string'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            class: "inputer",
            value: settingForm.value.purchaseType,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => settingForm.value.purchaseType = $event),
            options: _unref(purchaseType),
            getPopupContainer: _unref(getNode),
            disabled: settingForm.value.prodType == '10' || ['edit', 'watch'].includes(queryParams.value.type)
          }, null, 8, ["value", "options", "getPopupContainer", "disabled"])]),
          _: 1
        })) : _createCommentVNode("", true), settingForm.value.purchaseType == 'rent' && settingForm.value.prodType == '20' ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 2,
          label: "租期",
          name: "rentalPeriod",
          rules: [{
            required: true,
            message: '请选择租期',
            type: 'string'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            class: "inputer",
            value: settingForm.value.rentalPeriod,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => settingForm.value.rentalPeriod = $event),
            disabled: disabled.value,
            options: _unref(rentalOptions),
            getPopupContainer: _unref(getNode)
          }, null, 8, ["value", "disabled", "options", "getPopupContainer"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_a_form_item, {
          label: "商品信息",
          rules: [{
            required: true
          }]
        }, {
          default: _withCtx(() => {
            var _unref$settingForm$va, _unref$settingForm$va2;
            return [loading.value ? (_openBlock(), _createBlock(_component_a_skeleton_button, {
              key: 0,
              active: "",
              block: "",
              style: {
                "width": "740px"
              }
            })) : (_openBlock(), _createBlock(MultiComponents, {
              key: 1,
              ref_key: "multiComponentRef",
              ref: multiComponentRef,
              filterItems: settingForm.value.productNativeInfo,
              onSetProdId: setProdId,
              disabled: disabled.value,
              "default-lang": settingForm.value.defaultLang,
              onGetLastLange: changeLastLangInfo,
              showLastLangInfo: showLastLangInfo.value,
              nameRule: ((_unref$settingForm$va = _unref(describtionKey)[settingForm.value.prodType]) === null || _unref$settingForm$va === void 0 ? void 0 : _unref$settingForm$va.nameRule) || _unref(describtionKey)['10'].nameRule,
              desRule: ((_unref$settingForm$va2 = _unref(describtionKey)[settingForm.value.prodType]) === null || _unref$settingForm$va2 === void 0 ? void 0 : _unref$settingForm$va2.desRule) || _unref(describtionKey)['10'].desRule
            }, null, 8, ["filterItems", "disabled", "default-lang", "showLastLangInfo", "nameRule", "desRule"]))];
          }),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "prodId",
          rules: [{
            required: true,
            trigger: ['change', 'blur'],
            validator: ['31', '32'].includes(settingForm.value.prodType) ? _unref(validatePidAuto) : _unref(validateGooglePidAuto)
          }]
        }, {
          label: _withCtx(() => [_hoisted_7, _createVNode(_component_a_tooltip, {
            placement: "right"
          }, {
            title: _withCtx(() => [_createElementVNode("span", null, " 内购ID自动生成规则：包名+内购名称，全小写，不超过" + _toDisplayString(!['31', '32'].includes(settingForm.value.prodType) ? 135 : 40) + "字符 ", 1)]),
            default: _withCtx(() => [_createVNode(_unref(QuestionCircleOutlined), {
              class: "infoIcon ml4"
            })]),
            _: 1
          })]),
          default: _withCtx(() => [_createVNode(_component_a_input, {
            class: "inputer",
            value: settingForm.value.prodId,
            "onUpdate:value": _cache[5] || (_cache[5] = $event => settingForm.value.prodId = $event),
            placeholder: "请输入内购ID",
            disabled: Boolean(queryParams.value.id) || disabled.value,
            onFocus: _unref(handleProdIdFocus),
            onBlur: _unref(handleProdIdBlur)
          }, null, 8, ["value", "disabled", "onFocus", "onBlur"])]),
          _: 1
        }, 8, ["rules"]), _createVNode(_component_a_form_item, {
          label: "备注"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            class: "bigInputer",
            value: settingForm.value.remark,
            "onUpdate:value": _cache[6] || (_cache[6] = $event => settingForm.value.remark = $event),
            placeholder: "请输入",
            disabled: disabled.value,
            maxLength: 20
          }, null, 8, ["value", "disabled"])]),
          _: 1
        })]), ['31', '32'].includes(settingForm.value.prodType) ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_hoisted_9, settingForm.value.prodType === '31' ? (_openBlock(), _createBlock(BasicPlanNotAuto, {
          key: 0,
          detail: settingForm.value,
          disabled: disabled.value
        }, null, 8, ["detail", "disabled"])) : _createCommentVNode("", true), settingForm.value.prodType === '32' ? (_openBlock(), _createBlock(BasicPlanAuto, {
          key: 1,
          detail: settingForm.value,
          disabled: disabled.value
        }, null, 8, ["detail", "disabled"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createTextVNode(" 价格设置 "), _unref(showXsollaTab) ? (_openBlock(), _createBlock(_component_a_segmented, {
          key: 0,
          value: priceChannelTab.value,
          "onUpdate:value": _cache[7] || (_cache[7] = $event => priceChannelTab.value = $event),
          options: priceChannelTabOptions,
          class: "price-segmented",
          onChange: onPriceChannelTabChange
        }, {
          label: _withCtx(({
            value,
            title
          }) => [_createElementVNode("span", _hoisted_13, [_createElementVNode("span", {
            class: _normalizeClass(["price-tab-dot", {
              off: value === 'xsolla' && !xsollaConfig.value.enableThirdPay
            }])
          }, null, 2), _createTextVNode(" " + _toDisplayString(title), 1)])]),
          _: 1
        }, 8, ["value"])) : _createCommentVNode("", true)]), _withDirectives(_createElementVNode("div", null, [_unref(showTieredOption) ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 0,
          label: "定价模式"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_radio_group, {
            value: priceMode.value,
            "onUpdate:value": _cache[8] || (_cache[8] = $event => priceMode.value = $event),
            disabled: disabled.value,
            onChange: onPriceModeChange
          }, {
            default: _withCtx(() => [_createVNode(_component_a_radio, {
              value: "single"
            }, {
              default: _withCtx(() => [_createTextVNode("单一默认价格")]),
              _: 1
            }), _createVNode(_component_a_radio, {
              value: "tiered"
            }, {
              default: _withCtx(() => [_createTextVNode(" 多默认价格 "), _createVNode(_component_a_tag, {
                class: "tiered-tag ml4"
              }, {
                default: _withCtx(() => [_createTextVNode("按国家分层定价")]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }, 8, ["value", "disabled"])]),
          _: 1
        })) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_a_form_item, {
          label: "默认价格",
          required: ""
        }, {
          default: _withCtx(() => [settingForm.value.prodPriceCurrency === 'USD' ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_a_input_number, {
            class: "priceInputer",
            value: settingForm.value.prodPrice,
            "onUpdate:value": _cache[9] || (_cache[9] = $event => settingForm.value.prodPrice = $event),
            "addon-after": settingForm.value.prodPriceCurrency,
            step: 0.01,
            controls: false,
            precision: 2,
            "string-mode": "",
            disabled: disabled.value,
            onBlur: getChangePrice
          }, null, 8, ["value", "addon-after", "step", "disabled"])])) : (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_a_input_number, {
            class: "little-price",
            value: originUsdPrice.value,
            "onUpdate:value": _cache[10] || (_cache[10] = $event => originUsdPrice.value = $event),
            "addon-after": "USD",
            step: 0.01,
            controls: false,
            precision: 2,
            "string-mode": "",
            disabled: disabled.value,
            onBlur: getPriceByUsd
          }, null, 8, ["value", "step", "disabled"]), _createVNode(_component_SvgIcon, {
            "icon-class": "swap",
            class: "swap-icon"
          }), _createVNode(_component_a_input_number, {
            class: "little-price",
            value: settingForm.value.prodPrice,
            "onUpdate:value": _cache[11] || (_cache[11] = $event => settingForm.value.prodPrice = $event),
            "addon-after": settingForm.value.prodPriceCurrency,
            step: 0.01,
            controls: false,
            precision: 2,
            "string-mode": "",
            disabled: disabled.value,
            onBlur: getChangePrice
          }, null, 8, ["value", "addon-after", "step", "disabled"])]), _hoisted_17]))]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "本地价格",
          rules: [{
            required: true
          }]
        }, {
          default: _withCtx(() => [_createVNode(PriceBlock, {
            "prod-chnl": queryParams.value.prodChnl,
            "prod-price-currency": settingForm.value.prodPriceCurrency,
            "prod-type": settingForm.value.prodType,
            disabled: disabled.value,
            ref_key: "priceBlockRef",
            ref: priceBlockRef,
            onUpdateList: changeProdPrice,
            loading: priceLoading.value,
            taxRateSwitch: taxRateSwitch.value,
            originPriceList: originPriceList.value
          }, null, 8, ["prod-chnl", "prod-price-currency", "prod-type", "disabled", "loading", "taxRateSwitch", "originPriceList"])]),
          _: 1
        })], 512), [[_vShow, !_unref(showTieredOption) || priceMode.value === 'single']]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_a_form_item, {
          label: "层级默认价",
          rules: [{
            required: true
          }]
        }, {
          default: _withCtx(() => [_createVNode(TierDefaultPrice, {
            ref_key: "tierDefaultRef",
            ref: tierDefaultRef,
            "prod-chnl": queryParams.value.prodChnl,
            "prod-type": settingForm.value.prodType,
            "dbt-id": queryParams.value.dbtId,
            "prod-price-currency": settingForm.value.prodPriceCurrency,
            disabled: disabled.value,
            onChange: onTierDefaultPriceChange,
            onGoogleConvert: onGoogleTierConvert
          }, null, 8, ["prod-chnl", "prod-type", "dbt-id", "prod-price-currency", "disabled"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "本地价格",
          rules: [{
            required: true
          }]
        }, {
          default: _withCtx(() => [_createVNode(TierLocalPriceTable, {
            ref_key: "tierLocalRef",
            ref: tierLocalRef,
            pkg: settingForm.value.pkg,
            "prod-chnl": queryParams.value.prodChnl,
            "prod-type": settingForm.value.prodType,
            "prod-price-currency": settingForm.value.prodPriceCurrency,
            "dbt-id": queryParams.value.dbtId,
            "tier-levels": _unref(tierLevels),
            "pin-singapore": _unref(showRateSwitch) && taxRateSwitch.value,
            disabled: disabled.value,
            onChange: regenerateTiered
          }, null, 8, ["pkg", "prod-chnl", "prod-type", "prod-price-currency", "dbt-id", "tier-levels", "pin-singapore", "disabled"])]),
          _: 1
        })], 512), [[_vShow, _unref(showTieredOption) && priceMode.value === 'tiered']]), _unref(showRateSwitch) ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 1,
          label: "GST调价"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createVNode(_component_a_switch, {
            checked: taxRateSwitch.value,
            "onUpdate:checked": _cache[12] || (_cache[12] = $event => taxRateSwitch.value = $event),
            disabled: _unref(rateSwitchStatus) || priceLoading.value,
            onChange: onGstChange
          }, null, 8, ["checked", "disabled"]), _createElementVNode("div", {
            class: _normalizeClass(["taxRateText", {
              disabled: _unref(rateSwitchStatus) || priceLoading.value
            }]),
            onClick: onGstClick
          }, _hoisted_21, 2)])]),
          _: 1
        })) : _createCommentVNode("", true), priceMode.value === 'tiered' ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 2,
          label: "层级模板"
        }, {
          default: _withCtx(() => [_createVNode(TierTemplateSwitch, {
            modelValue: tierTemplateEnabled.value,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => tierTemplateEnabled.value = $event),
            disabled: disabled.value
          }, null, 8, ["modelValue", "disabled"])]),
          _: 1
        })) : _createCommentVNode("", true)], 512), [[_vShow, priceChannelTab.value === 'google']]), _createVNode(_component_a_spin, {
          spinning: xsollaPriceLoading.value || _unref(officialPriceLoading)
        }, {
          default: _withCtx(() => [_withDirectives(_createVNode(_component_a_form, {
            model: _unref(thirdPartyDraft),
            "label-col": {
              style: 'width: 98px'
            },
            class: "third-party-pay-form"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "开启三方支付"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_22, [_createVNode(_component_a_switch, {
                checked: xsollaConfig.value.enableThirdPay,
                disabled: disabled.value,
                onChange: onXsollaEnableChange
              }, null, 8, ["checked", "disabled"]), _hoisted_23])]),
              _: 1
            }), xsollaConfig.value.enableThirdPay ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createVNode(_component_a_form_item, {
              label: "开启渠道",
              required: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_a_radio_group, {
                value: thirdPartyChannel.value,
                "onUpdate:value": _cache[14] || (_cache[14] = $event => thirdPartyChannel.value = $event),
                disabled: disabled.value
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(GOOGLE_THIRD_PARTY_CHANNEL_OPTIONS, item => {
                  return _createVNode(_component_a_radio, {
                    key: item.value,
                    value: item.value
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                    _: 2
                  }, 1032, ["value"]);
                }), 64))]),
                _: 1
              }, 8, ["value", "disabled"])]),
              _: 1
            }), _createVNode(ThirdPartyPricePanel, {
              ref_key: "thirdPartyPanelRef",
              ref: thirdPartyPanelRef,
              modelValue: _unref(thirdPartyDraft),
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => _isRef(thirdPartyDraft) ? thirdPartyDraft.value = $event : null),
              "official-price": _unref(thirdPartyOfficialPrice),
              "missing-official-tip": _unref(thirdPartyOfficialTip),
              "channel-name": "Xsolla",
              "show-discount": false,
              "show-price-tips": false,
              "allow-above-official": true,
              disabled: disabled.value,
              onPriceCommit: refreshXsollaRuPrice
            }, {
              extra: _withCtx(() => [_createVNode(XsollaNativePriceFields, {
                ref_key: "xsollaNativeRef",
                ref: xsollaNativeRef,
                "model-value": xsollaConfig.value,
                disabled: disabled.value,
                onNativePriceChange: onXsollaNativePriceChange,
                onVatChange: onXsollaVatChange
              }, null, 8, ["model-value", "disabled"])]),
              _: 1
            }, 8, ["modelValue", "official-price", "missing-official-tip", "disabled"])], 64)) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["model"]), [[_vShow, _unref(showXsollaTab) && priceChannelTab.value === 'xsolla']])]),
          _: 1
        }, 8, ["spinning"])]), settingForm.value.prodType === '32' ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createVNode(DiscountPlan, {
          ref_key: "discountPlanRef",
          ref: discountPlanRef,
          detail: settingForm.value,
          priceArr: _unref(discountPriceArr),
          "read-only": disabled.value
        }, null, 8, ["detail", "priceArr", "read-only"])])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["model"]), _withDirectives(_createElementVNode("div", {
        class: "submitBlock",
        style: _normalizeStyle(_unref(submitBlockStyle))
      }, [_createVNode(_component_a_button, {
        onClick: cancel
      }, {
        default: _withCtx(() => [_createTextVNode("取 消")]),
        _: 1
      }), _createVNode(_component_a_button, {
        loading: saveLoading.value,
        class: "ml8",
        type: "primary",
        onClick: save,
        disabled: _unref(officialPriceLoading) || xsollaPriceLoading.value
      }, {
        default: _withCtx(() => [_createTextVNode(" 保 存 ")]),
        _: 1
      }, 8, ["loading", "disabled"]), _withDirectives(_createElementVNode("div", _hoisted_25, [_createVNode(_component_a_checkbox, {
        checked: saveNext.value,
        "onUpdate:checked": _cache[16] || (_cache[16] = $event => saveNext.value = $event)
      }, {
        default: _withCtx(() => [_createTextVNode("连续创建")]),
        _: 1
      }, 8, ["checked"])], 512), [[_vShow, !queryParams.value.id]])], 4), [[_vShow, !disabled.value]]), _createVNode(RecordDrawer, {
        visible: recordVisible.value,
        "onUpdate:visible": _cache[17] || (_cache[17] = $event => recordVisible.value = $event)
      }, null, 8, ["visible"]), _createVNode(UnusedTierConfirmModal, {
        open: unusedModalOpen.value,
        "onUpdate:open": _cache[18] || (_cache[18] = $event => unusedModalOpen.value = $event),
        "unused-tiers": unusedTiers.value,
        loading: tieredSaving.value,
        onConfirm: onUnusedConfirm,
        onCancel: onUnusedCancel
      }, null, 8, ["open", "unused-tiers", "loading"]), _createVNode(PriceModeConfirmModal, {
        open: priceModeConfirmOpen.value,
        "onUpdate:open": _cache[19] || (_cache[19] = $event => priceModeConfirmOpen.value = $event),
        mode: priceMode.value,
        loading: saveLoading.value,
        onConfirm: onPriceModeConfirm,
        onCancel: onPriceModeConfirmCancel
      }, null, 8, ["open", "mode", "loading"])]);
    };
  }
});